import { SectionDestination } from './section-destination';
export class InnerSectionDestination extends SectionDestination {
}
